import React from 'react';
import Label from '../Label';

interface Props {
  label: string;
  id: string;
  name?: string;
  required?: boolean;
  placeholder?: string;
}

function Textarea(props: Props) {
  const { label, id, name, required, placeholder } = props;

  return (
    <div className='textarea'>
      <Label text={`${label}${required ? '' : ' (optional)'}`} htmlFor={id} />
      <textarea id={id} name={name ?? id} required={required} placeholder={placeholder} />
    </div>
  );
}

export default Textarea;
